// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .back{
    background-color: blue;
    height: 100vh;
    /* background-image: linear-gradient(rgb(11, 26, 65), black); */
    background: linear-gradient(180deg, #020F32 0%, rgba(2, 15, 50, 0.00) 100%);
    border: solid;
  }
  .h{
    color: white;
    font-size: 4vw;
    margin-top: 7vw;
  }
  .ha{
    color: white;
    font-size: 1.5vw;
    margin-top: 3vw;
  }
  .inm{
    font-size: 1.5vw;
    width: 8vw;
    margin-left: 46vw;
    margin-top: 2vw;
    background-color: white;
    border-radius: 2vw;
  }
  .d{
    color: white;
    font-size: 1.5vw;
    margin-top: 5vw;
  }
  .e{
    color: white;
    font-size: 1vw;
    margin-top: 1vw;
  }

  @media (max-width: 768px) {
    .h{
      margin-top: 20vw !important;
      font-size: 8vw;
    }
    .ha{
      font-size: 3vw;
      width: 70vw;
      margin-left: 13vw;
      margin-top: 4vw;
    }
    .inm{
      margin-top: 8vw;
      width: 15vw;
      padding: 1vw;
      font-size: 3vw;
      border-radius: 3vw;
      margin-left: 41vw;
    }
    .d{
      font-size: 3vw;
    }
    .e{
      margin-top: 5vw;
      font-size: 3vw;
    }
  }
/*==================================================================== logout =================================================================*/

.logout-back{
  height: 160vh;
}
.logout-table-back{
  background-color: white;
}
@media (max-width: 768px) {
  .logout-back{
    height: 220vh !important;
  }

}
@media (max-width: 610px) {
  .logout-back{
    height: 180vh !important;
  }

}
@media (max-width: 768px) {
  .logout-back{
    height: 160vh !important;
  }

}
   


  /*======================================navbar========================= */
   .navbar {
    display: flex;
    
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    height: 10vh;
    /* background-color: rgb(0, 26, 102);  */
    background-color: #020131;
    /* border-bottom: thin solid rgba(255, 255, 255, 0.284); */
    box-shadow: 0 2px 4px  rgb(0, 26, 102);
  }
  .user-welcome{
    color: white;
  }
  
  .logo {
    flex: 1 1;
    font-size: 3vw;
    margin-left: 1vw;
    color: white; 
    font-weight: bold;
  }
  
  .nav-links {
    display: flex;
    color: white;
    justify-content: space-between;
    gap: 1vw;
    font-size: 1.5vw;
    margin-right: 3vw;
  }
  
  .auth-buttons {
    display: flex;
    gap: 1vw;
    margin-right: 2vw;
    margin-left: 2vw;
    /* border: thick solid #32a1ce; */
  }
  
  .transparent-button {
    background: none;
    border: none;
    color: rgb(9, 9, 9);
    cursor: pointer;
    font-size: 1.5vw;
  }
  
  .transparent-button:hover {
    text-decoration: underline;
  }
  .signup {
    background-color: white;
    padding: 1vw  ;
    border-radius: 2vw;
    width: 6.5vw;
    /* border: thick solid #32a1ce; */
    
  }
  .l{
    padding: 1vw;
    /* border: thick solid #32a1ce; */
  }
  .welcome-msg{
    font-size: 1.5vw;
  }



  @media (max-width: 768px) {
    .navbar{
      height: 20vh;
    }
    .back{
      height: 90vh;
    }
    .logo{
      font-size: 5vw;
      margin-left: 26vw;
    }
    .nav-links {
      font-size: 3vw;
    }
    .transparent-button {
      font-size: 3vw;
    }
    .snav{
      width: 11vw;
      border-radius: 3vw;
      /* margin-left: 20vw; */
    }
    .l{
      margin-left: 17vw;
    }
    .welcome-msg{
      font-size: 3vw;
    }
    .nav-links {
      margin-right: 0vw;
      margin-left: 5vw;
      gap:5vw;
      /* justify-content: space-between; */
      align-items: center !important;
      margin-bottom: 2vw;
      margin-top: 2vw;
    }
    .auth-buttons{
      margin-left: 17vw;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"EAAE;IACE,sBAAsB;IACtB,aAAa;IACb,+DAA+D;IAC/D,2EAA2E;IAC3E,aAAa;EACf;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,2BAA2B;MAC3B,cAAc;IAChB;IACA;MACE,cAAc;MACd,WAAW;MACX,iBAAiB;MACjB,eAAe;IACjB;IACA;MACE,eAAe;MACf,WAAW;MACX,YAAY;MACZ,cAAc;MACd,kBAAkB;MAClB,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,eAAe;MACf,cAAc;IAChB;EACF;AACF,gJAAgJ;;AAEhJ;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,wBAAwB;EAC1B;;AAEF;AACA;EACE;IACE,wBAAwB;EAC1B;;AAEF;AACA;EACE;IACE,wBAAwB;EAC1B;;AAEF;;;;EAIE,yEAAyE;GACxE;IACC,aAAa;;IAEb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,0DAA0D;IAC1D,sCAAsC;EACxC;EACA;IACE,YAAY;EACd;;EAEA;IACE,SAAO;IACP,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;;EAEnC;EACA;IACE,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;;;;EAIA;IACE;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,cAAc;MACd,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,cAAc;IAChB;IACA;MACE,WAAW;MACX,kBAAkB;MAClB,uBAAuB;IACzB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,OAAO;MACP,oCAAoC;MACpC,8BAA8B;MAC9B,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["  .back{\r\n    background-color: blue;\r\n    height: 100vh;\r\n    /* background-image: linear-gradient(rgb(11, 26, 65), black); */\r\n    background: linear-gradient(180deg, #020F32 0%, rgba(2, 15, 50, 0.00) 100%);\r\n    border: solid;\r\n  }\r\n  .h{\r\n    color: white;\r\n    font-size: 4vw;\r\n    margin-top: 7vw;\r\n  }\r\n  .ha{\r\n    color: white;\r\n    font-size: 1.5vw;\r\n    margin-top: 3vw;\r\n  }\r\n  .inm{\r\n    font-size: 1.5vw;\r\n    width: 8vw;\r\n    margin-left: 46vw;\r\n    margin-top: 2vw;\r\n    background-color: white;\r\n    border-radius: 2vw;\r\n  }\r\n  .d{\r\n    color: white;\r\n    font-size: 1.5vw;\r\n    margin-top: 5vw;\r\n  }\r\n  .e{\r\n    color: white;\r\n    font-size: 1vw;\r\n    margin-top: 1vw;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .h{\r\n      margin-top: 20vw !important;\r\n      font-size: 8vw;\r\n    }\r\n    .ha{\r\n      font-size: 3vw;\r\n      width: 70vw;\r\n      margin-left: 13vw;\r\n      margin-top: 4vw;\r\n    }\r\n    .inm{\r\n      margin-top: 8vw;\r\n      width: 15vw;\r\n      padding: 1vw;\r\n      font-size: 3vw;\r\n      border-radius: 3vw;\r\n      margin-left: 41vw;\r\n    }\r\n    .d{\r\n      font-size: 3vw;\r\n    }\r\n    .e{\r\n      margin-top: 5vw;\r\n      font-size: 3vw;\r\n    }\r\n  }\r\n/*==================================================================== logout =================================================================*/\r\n\r\n.logout-back{\r\n  height: 160vh;\r\n}\r\n.logout-table-back{\r\n  background-color: white;\r\n}\r\n@media (max-width: 768px) {\r\n  .logout-back{\r\n    height: 220vh !important;\r\n  }\r\n\r\n}\r\n@media (max-width: 610px) {\r\n  .logout-back{\r\n    height: 180vh !important;\r\n  }\r\n\r\n}\r\n@media (max-width: 768px) {\r\n  .logout-back{\r\n    height: 160vh !important;\r\n  }\r\n\r\n}\r\n   \r\n\r\n\r\n  /*======================================navbar========================= */\r\n   .navbar {\r\n    display: flex;\r\n    \r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px;\r\n    height: 10vh;\r\n    /* background-color: rgb(0, 26, 102);  */\r\n    background-color: #020131;\r\n    /* border-bottom: thin solid rgba(255, 255, 255, 0.284); */\r\n    box-shadow: 0 2px 4px  rgb(0, 26, 102);\r\n  }\r\n  .user-welcome{\r\n    color: white;\r\n  }\r\n  \r\n  .logo {\r\n    flex: 1;\r\n    font-size: 3vw;\r\n    margin-left: 1vw;\r\n    color: white; \r\n    font-weight: bold;\r\n  }\r\n  \r\n  .nav-links {\r\n    display: flex;\r\n    color: white;\r\n    justify-content: space-between;\r\n    gap: 1vw;\r\n    font-size: 1.5vw;\r\n    margin-right: 3vw;\r\n  }\r\n  \r\n  .auth-buttons {\r\n    display: flex;\r\n    gap: 1vw;\r\n    margin-right: 2vw;\r\n    margin-left: 2vw;\r\n    /* border: thick solid #32a1ce; */\r\n  }\r\n  \r\n  .transparent-button {\r\n    background: none;\r\n    border: none;\r\n    color: rgb(9, 9, 9);\r\n    cursor: pointer;\r\n    font-size: 1.5vw;\r\n  }\r\n  \r\n  .transparent-button:hover {\r\n    text-decoration: underline;\r\n  }\r\n  .signup {\r\n    background-color: white;\r\n    padding: 1vw  ;\r\n    border-radius: 2vw;\r\n    width: 6.5vw;\r\n    /* border: thick solid #32a1ce; */\r\n    \r\n  }\r\n  .l{\r\n    padding: 1vw;\r\n    /* border: thick solid #32a1ce; */\r\n  }\r\n  .welcome-msg{\r\n    font-size: 1.5vw;\r\n  }\r\n\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    .navbar{\r\n      height: 20vh;\r\n    }\r\n    .back{\r\n      height: 90vh;\r\n    }\r\n    .logo{\r\n      font-size: 5vw;\r\n      margin-left: 26vw;\r\n    }\r\n    .nav-links {\r\n      font-size: 3vw;\r\n    }\r\n    .transparent-button {\r\n      font-size: 3vw;\r\n    }\r\n    .snav{\r\n      width: 11vw;\r\n      border-radius: 3vw;\r\n      /* margin-left: 20vw; */\r\n    }\r\n    .l{\r\n      margin-left: 17vw;\r\n    }\r\n    .welcome-msg{\r\n      font-size: 3vw;\r\n    }\r\n    .nav-links {\r\n      margin-right: 0vw;\r\n      margin-left: 5vw;\r\n      gap:5vw;\r\n      /* justify-content: space-between; */\r\n      align-items: center !important;\r\n      margin-bottom: 2vw;\r\n      margin-top: 2vw;\r\n    }\r\n    .auth-buttons{\r\n      margin-left: 17vw;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
